export enum FreelancerDrawerTab {
    Profile = 'PROFILE',
    Messages = 'MESSAGES',
}

export type FreelancerInfo = {
    profileId?: string;
    fullName: string;
    headline?: string;
    photoUrl?: string;
};
